module.exports = __webpack_public_path__ + "img/1504.6fdeaf21.jpg";